import { IAction } from "store";
import { DealAction } from "../../actions";
import { Measure } from "../../types";
import { reducer } from "../index";

reducer.createHandler(DealAction.GetMeasuresSuccess, (state, { payload }: IAction<Measure[]>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    measures: payload
  }
}));

reducer.createHandler(DealAction.CreateMeasureSuccess, (state, { payload }: IAction<Measure>) => {
  return {
    ...state,
    dealModule: {
      ...state.dealModule,
      measures: [payload, ...state.dealModule.measures]
    }
  };
});

reducer.createHandler(DealAction.UpdateMeasureSuccess, (state, { payload }: IAction<Measure>) => {
  return {
    ...state,
    dealModule: {
      ...state.dealModule,
      measures: state.dealModule.measures.map((measure) => (measure.id === payload.id ? payload : measure))
    }
  };
});

reducer.createHandler(DealAction.DeleteMeasureSuccess, (state, { payload }: IAction<number>) => {
  return {
    ...state,
    dealModule: {
      ...state.dealModule,
      measures: state.dealModule.measures.filter((measures) => measures.id !== payload)
    }
  };
});
